import { Form, Input, Select, Button } from "antd";
import { ToastService } from "@shared/lib/services";
import { INVOICE_SUB_TYPE, INVOICE_TYPE } from "@shared/lib/types/briefInvoice";
import { InputNumber } from "@shared/ui/InputNumber";
const { Option } = Select;

interface CreateBriefInvoiceEntryProps {
  onSubmit: (values: any) => void;
  isSubmitting: boolean;
  onCancel: () => void;
}

export function CreateBriefInvoiceEntry({
  onSubmit,
  isSubmitting,
  onCancel,
}: CreateBriefInvoiceEntryProps) {
  const [form] = Form.useForm();

  const handleSubmit = (values: any) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        subType: "Others",
      }}
      onFinishFailed={({ errorFields }) => {
        if (errorFields.length) {
          ToastService.error(
            "Error Submitting Form. Please fill all required fields."
          );
        }
      }}
    >
      <Form.Item name="invoiceNumber" label="Invoice Number">
        <Input placeholder="Enter Invoice Number" />
      </Form.Item>
      <Form.Item
        name="url"
        label="URL"
        rules={[{ type: "url", message: "Please enter a valid URL" }]}
      >
        <Input placeholder="Enter URL" />
      </Form.Item>

      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Type is required" }]}
      >
        <Select placeholder="Select Type">
          {Object.values(INVOICE_TYPE).map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="subType"
        label="Sub Type"
        rules={[{ required: true, message: "Sub Type is required" }]}
      >
        <Select placeholder="Select Sub Type">
          {Object.values(INVOICE_SUB_TYPE).map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="baseAmount"
        label="Base Amount"
        rules={[{ required: true, message: "Base Amount is required" }]}
      >
        <InputNumber
          type="number"
          style={{ width: "100%" }}
          placeholder="Enter Base Amount"
          min={0}
        />
      </Form.Item>

      <Form.Item
        name="gstAmount"
        label="GST Amount"
        rules={[{ required: true, message: "GST Amount is required" }]}
      >
        <InputNumber
          type="number"
          style={{ width: "100%" }}
          placeholder="Enter GST Amount"
          min={0}
        />
      </Form.Item>

      <Form.Item>
        <div
          style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}
        >
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            {isSubmitting ? "Creating..." : "Create"}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
}
